import { useEffect, useState } from 'react'
import { DeviceType } from '../types'
import { useErrorHandling } from '@/tools/o11y/client'

export const isIOS = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
}

export const isAndroid = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false
  }
  return /Android/i.test(navigator.userAgent)
}
const getOS = (): DeviceType => {
  if (isIOS()) {
    return DeviceType.IOS
  } else if (isAndroid()) {
    return DeviceType.ANDROID
  }
  return DeviceType.UNKNOWN
}
export const useDeviceType = () => {
  const [OS, setOS] = useState<DeviceType>(DeviceType.UNKNOWN)
  const { execWithErrorTracking } = useErrorHandling()

  useEffect(() => {
    execWithErrorTracking(() => {
      setOS(getOS())
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return { OS }
}
